import React from 'react'
import styles from "./ViewerComponent.module.css";

const ViewerComponent = () => {
  return (
    <div className={styles.viewerContainer}>
      
    </div>
  )
}

export default ViewerComponent
